var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.paymentLoading || _vm.payment
    ? _c(
        "div",
        {
          ref: "container",
          staticClass: "payment details-container",
          class: {
            "details-containerTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
        },
        [
          _c(
            "h3",
            {
              staticClass: "details-container__header",
              class: {
                "details-container__headerTs":
                  _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
              },
            },
            [_vm._v(_vm._s(_vm.data.payment.title))]
          ),
          _vm._v(" "),
          _vm.paymentLoading
            ? _c(
                "div",
                { staticClass: "payment__content details-container__body" },
                [
                  _c("PlaneLoader", {
                    attrs: { brandName: _vm.data.brandNameFormatted },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.payment
            ? _c(
                "div",
                { staticClass: "payment__content details-container__body" },
                [
                  !_vm.isReservation
                    ? [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.payment.summaryView,
                                expression: "!payment.summaryView",
                              },
                            ],
                          },
                          [
                            _c("div", {
                              staticClass: "details-container__body-intro",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.payment.descriptionHtml
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "payment__types" },
                              [
                                _c("Input", {
                                  attrs: {
                                    name: "amountToPay",
                                    required: true,
                                    options: _vm.amountsToPay,
                                    optionsRadio: true,
                                    optionValueKey: "value",
                                    optionLabelKey: "label",
                                    startingValue:
                                      _vm.payment.data.depositAmount,
                                    vuexPath: _vm.vuexPath,
                                    brand: _vm.data.brandNameFormatted,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("Input", {
                              attrs: {
                                name: "cardTypeId",
                                label: "Payment card type",
                                placeholder: "Select card type",
                                required: true,
                                options: _vm.payment.data.cardTypes,
                                optionValueKey: "id",
                                optionLabelKey: "name",
                                vuexPath: _vm.vuexPath,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.payment.summaryView
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "details-container__edit-button",
                                  class: {
                                    "details-container__edit-buttonTs":
                                      _vm.data.brandNameFormatted ===
                                      _vm.Brand.Travelsphere,
                                  },
                                  attrs: {
                                    "aria-label": "Edit your details",
                                    title: "Click to edit your details",
                                  },
                                  on: { click: _vm.edit },
                                },
                                [_vm._v("Edit")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "passenger-summary" }, [
                                _c(
                                  "div",
                                  { staticClass: "passenger-summary__field" },
                                  [
                                    _c(
                                      "b",
                                      {
                                        staticClass:
                                          "passenger-summary__attribute",
                                      },
                                      [_vm._v("Payment amount")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "passenger-summary__value",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency(
                                              _vm.paymentData.amountToPay
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "passenger-summary__field" },
                                  [
                                    _c(
                                      "b",
                                      {
                                        staticClass:
                                          "passenger-summary__attribute",
                                      },
                                      [_vm._v("Card type")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "passenger-summary__value",
                                      },
                                      [_vm._v(_vm._s(_vm.getCardName()))]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    : _c(
                        "div",
                        {
                          staticClass: "error-message nb",
                          class: { "error-message--confirmed": _vm.showButton },
                        },
                        [
                          _c("div", { staticClass: "error-message__icon ni" }),
                          _vm._v(" "),
                          _vm.passengersHaveMobilityLimitations
                            ? _c("div", {
                                staticClass: "error-message__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.payment.medicalWarning
                                  ),
                                },
                              })
                            : _c("div", {
                                staticClass: "error-message__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.payment.generalWarning
                                  ),
                                },
                              }),
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showButton,
                          expression: "showButton",
                        },
                      ],
                      staticClass: "details-container__footer",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn details-container__submit",
                          class: {
                            btn_Ts:
                              _vm.data.brandNameFormatted ===
                              _vm.Brand.Travelsphere,
                          },
                          attrs: {
                            "aria-label": "Save and continue",
                            title: "Click to save and continue",
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Save and continue")]
                      ),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }